import React, { useState, useEffect, InputHTMLAttributes } from 'react';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { FieldProps } from 'formik';

// types
import RootState from 'ducks/RootState';
import { ExternalAsset } from 'ducks/merchantDucks/items/types';

// actions
import {
  loadInitialExternalAssets as loadInitialExternalAssetsAction,
  loadBrightcoveExternalAssets as loadBrightcoveExternalAssetsAction,
  // types
  LoadExternalAssetsParams,
} from 'ducks/merchantDucks/items/actions';

// components
import ThumbnailItemPicker, { Item } from 'components/ThumbnailItemPicker';

// images
import previewImg from 'assets/pics/ip-preview-premium.jpg';

interface BrightcoveVideo {
  id: string;
  name: string;
  images: {
    thumbnail?: { src?: string };
  };
  [key: string]: any;
}

interface StateProps {
  externalAssets: ExternalAsset;
}

interface DispatchProps {
  loadBrightcoveExternalAssets: (params: LoadExternalAssetsParams) => any;
  loadInitialExternalAssetsNew: (params: LoadExternalAssetsParams) => any;
}

interface OwnProps {
  accountId: string;
  onSelect: (item: Item) => void;
}

type Props = InputHTMLAttributes<HTMLInputElement> & FieldProps & StateProps & DispatchProps & OwnProps;

const BrightcoveVideoMenu = ({
  externalAssets: { videos, total: totalItemsCount, isFetching },
  loadInitialExternalAssetsNew,
  loadBrightcoveExternalAssets,
  field: { name, value },
  form: { setFieldValue },
  accountId,
  onSelect,
}: Props) => {
  const [currentPage, setPage] = useState(1);

  useEffect(() => {
    if (accountId && !isFetching) {
      loadInitialExternalAssetsNew({ type: 'brightcove', page: 0 });
    }
  }, []);

  const items = videos.map(
    ({ id, name: label, images: { thumbnail: { src: thumbnail = previewImg } = {} } = {} }: BrightcoveVideo) => ({
      id,
      label,
      thumbnail,
    })
  );

  const onPageSelect = (pageSelection: number, limit: number) => {
    loadBrightcoveExternalAssets({ type: 'brightcove', page: pageSelection - 1, limit });
    setPage(pageSelection);
  };

  const onItemSelect = (item: Item) => {
    const { id } = item;

    setFieldValue(name, id);
    onSelect(item);
  };

  return (
    <ThumbnailItemPicker
      currentValue={value}
      items={items}
      totalItemsCount={totalItemsCount}
      numColumns={3}
      onPageSelect={onPageSelect}
      onItemSelect={onItemSelect}
      currentPage={currentPage}
      isLoading={isFetching}
      showItemId={false}
      headerText="Choose your video"
    />
  );
};

export const mapStateToProps: MapStateToProps<StateProps, OwnProps, RootState> = (state) => ({
  externalAssets: state.items.externalAssets,
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  loadInitialExternalAssetsNew: loadInitialExternalAssetsAction,
  loadBrightcoveExternalAssets: loadBrightcoveExternalAssetsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrightcoveVideoMenu);
